import { render, staticRenderFns } from "./BorrowStatusDropdown.vue?vue&type=template&id=1035dca8&scoped=true&"
import script from "./BorrowStatusDropdown.vue?vue&type=script&lang=js&"
export * from "./BorrowStatusDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BorrowStatusDropdown.vue?vue&type=style&index=0&id=1035dca8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1035dca8",
  null
  
)

export default component.exports